<template>
  <div class="page">
    <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
    <div class="totle">
      <div class="titletext">
        <div class="titletextin">
          本课程仅限ACMED会员观看
        </div>
        点击继续完成
      </div>
      <div class="titlebtn" @click="gorz()">
        <div class="iconout"><img src="../../assets/images/enterinicon.png" alt="" class="btnicon"></div>
        <div class="btntext" >继续申请</div>
      </div>
      <div class="centertext">
        <span class="centerbold">ACMED即</span>中国医药教育协会皮肤与健康教育专业委员会，此次申请会员为委员或青年委员，需经审批，请耐心等待!
      </div>
      <div class="qrcode">
        <img src="../../assets/images/enterincode.png" class="okqrcode1" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "uploadInfo",
  data() {
    return {};
  },
  computed: {},
  created() {
    document.title = "加入ACMED";
  },
  beforeDestroy() { },
  methods: {
    gorz() {
      this.$router.replace({
        path: "/newrenzheng"
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(247, 249, 253);
}

.totle {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
}

.maintitle {
  margin: auto;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 1rem;
}

.okqrcode {
  display: block;
  margin: auto;
  width: 70%;
  margin-top: 1rem;
}

.okqrcode1 {
  display: block;
  margin: auto;
  width: 55%;
  margin-top: 1rem;
}

.maininner {
  width: 73%;
  margin: auto;
  font-size: 20px;
}

.topimg {
  width: 100%;
  height: 100%;
  display: block;
}

.titletext {
  text-align: center;
  font-size: .6rem;
  font-weight: bold;
  color: #b42d28;
}

.titletextin {
  text-align: center;
  font-size: .6rem;
  font-weight: normal;
}

.titlebtn {
  width: 37%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  padding: .4rem 0.1rem;
  justify-content: center;
  background-image: linear-gradient(to right, #004699, #009EEC);
  color: #fff;
  margin: 0.5rem auto;
}

.btnicon {
  display: block;
  width: 100%;
}

.iconout {
  width: 26%;
  padding-right: 0.2rem;
}

.btntext {
  font-size: .35rem;
  margin-top: .2rem;
}

.centertext {
  width: 78%;
  margin: auto;
  text-align: center;
  color: #34426C;
}

.centerbold {
  font-weight: 900;
}
</style>